export const licenseKey = import.meta.env.VITE_DEVEXTREME_KEY
